export default {
  'appConfig.title': '应用设置',

  'appConfig.field.name': '名称',
  'appConfig.field.keys': '属性',
  'appConfig.field.fieldName': '属性名',
  'appConfig.field.fieldValue': '属性值',

  'appConfig.action.addField': '新增属性',

  'appConfig.name.isRequired': '配置名必填',
  'appConfig.fieldName.isRequired': '属性名必填',
  'appConfig.fieldValue.isRequired': '属性值必填',

  'appConfig.deletion.promptTitle': '删除提示',
  'appConfig.deletion.promptContent': '确认要删除此配置吗？',

  'appConfig.update.success': '更新配置成功',
};
